import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import Select from "react-select"
import GlobalHelper from "../../../common/GlobalHelper"
import ActionButton from "../../../common/button/actionbutton.component"
import MoneyInputForm from "../../../common/form/moneyinput.component"
import Icon from "../../../common/icon/icon.component"
import { SelectOption } from "../../../common/types/select"
import IntlProps from "../../../state/helpers/IntlProps"
import { AdditionalMethodForm, REFUND_TYPE } from "../../../state/invoice/Constants"
import "./AdditionalRefundMethods.scss"

type OwnProps = {
    refundType: REFUND_TYPE,
    leftToRefund: number,
    form: AdditionalMethodForm[],
    refundMethods: SelectOption<string>[],
    onAdd: () => void,
    onRemove: (id: string) => void,
    onEditRefundAmount: (id: string, amount: number) => void,
    onEditRefundMethod: (id: string, method: string) => void,
}

const AdditionalRefundMethods = (props: OwnProps & IntlProps) => {
    const getUnselectedRefundMethods = (selected: string): SelectOption<string>[] => {
        const selectedMethods = props.form.reduce((methods: string[], row: AdditionalMethodForm) => {
            return row.refundMethod === selected ? methods : [...methods, row.refundMethod]
        }, [])
        return props.refundMethods.filter(method => !selectedMethods.includes(method.value))
    }

    const canAddNewMethod = (): boolean => {
        if (props.refundType === REFUND_TYPE.REFUND_ACCOUNT) {
            return !props.form.length && props.leftToRefund > 0
        }

        return props.form.every(row => row.refundMethod !== "") && props.leftToRefund > 0
    }

    return (
        <div className="AdditionalRefundMethods">
            <h5>
                <FormattedMessage
                    id="payment_refund_modal.additional_refund_methods.title."
                    defaultMessage="Additional refund methods"
                />
            </h5>
            <table className="table">
                <tbody>
                    {props.form.map(row => (
                        <tr key={row.id}>
                            <td className="refund-method-col" >
                                <Select
                                    value={row.refundMethod}
                                    options={getUnselectedRefundMethods(row.refundMethod)}
                                    onChange={({ value }) => props.onEditRefundMethod(row.id, value)}
                                    disabled={props.refundType === REFUND_TYPE.REFUND_ACCOUNT}
                                    clearable={false}
                                    required
                                />
                            </td>
                            <td className="spacer-col" />
                            <td className="refund-col">
                                <MoneyInputForm
                                    className='amount-input'
                                    currency={row.currency}
                                    value={GlobalHelper.moneyFormat(row.refundAmount)}
                                    onChange={(amount: number) => props.onEditRefundAmount(row.id, amount)}
                                    disabled={!row.refundMethod}
                                    debounced={true}
                                    debounceTimeout={1000}
                                />
                            </td>
                            <td className="delete-row-col">
                                <a onClick={() => props.onRemove(row.id)}>
                                    <Icon value="times-circle" />
                                </a>
                            </td>
                        </tr>
                    ))}
                    <tr key="add-refund-method-row">
                        <td className="add-refund-method-col" >
                            <ActionButton
                                type="button"
                                className="btn btn-outline-primary"
                                isLoading={false}
                                disabled={!canAddNewMethod()}
                                onClick={props.onAdd}
                            >
                                <Icon value="plus-circle" />
                                <FormattedMessage
                                    id="payment_refund_modal.additional_refund_method.add_method_btn"
                                    defaultMessage="Add refund method"
                                />
                            </ActionButton>
                        </td>
                        <td className="spacer-col" />
                        <td className="refund-col" />
                        <td className="delete-row-col" />
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default injectIntl(AdditionalRefundMethods)



// WEBPACK FOOTER //
// ./src/invoice/components/AdditionalRefundMethods/AdditionalRefundMethods.tsx